/*
 * Copyright (c) 2024. World Wide Generation Ltd
 */

import { RootInitiativeData } from '../types/initiative';
import { AppConfig } from '../types/app';
import { useRouteMatch } from 'react-router-dom';
import { isValidCompanyTrackerRoot } from '../routes/company-tracker/utils';

interface UseAppConfig {
  organization?: Pick<RootInitiativeData, 'appConfig'>;
  rootAppPath?: string;
}

export const useRouteAppConfig = (params: UseAppConfig): AppConfig | undefined => {
  const { organization, rootAppPath: rootAppPathOverride } = params;

  const match = useRouteMatch<{ rootAppPath: string }>({ path: '/:rootAppPath/' });
  const rootAppPath = rootAppPathOverride ?? match?.params.rootAppPath;
  if (!rootAppPath) {
    return organization?.appConfig;
  }

  if (isValidCompanyTrackerRoot(rootAppPath) || rootAppPath === organization?.appConfig?.rootAppPath) {
    return organization?.appConfig;
  }

  return undefined;
};
